module.exports = __webpack_public_path__ + "img/base_page_title_login_top.240e0d72.png";